var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2929 6.97917C11.6834 7.3697 11.6834 8.00286 11.2929 8.39339L8.75735 10.9289H17.6568C18.2091 10.9289 18.6568 11.3766 18.6568 11.9289C18.6568 12.4812 18.2091 12.9289 17.6568 12.9289H8.75735L11.2929 15.4645C11.6834 15.855 11.6834 16.4881 11.2929 16.8787C10.9024 17.2692 10.2692 17.2692 9.87867 16.8787L5.63603 12.636C5.44153 12.4415 5.3439 12.1868 5.34314 11.9319C5.34314 11.9289 5.34314 11.9259 5.34316 11.9229C5.34395 11.7895 5.37086 11.6623 5.41902 11.5461C5.46782 11.4282 5.54016 11.3177 5.63603 11.2218L9.87867 6.97917C10.2692 6.58865 10.9024 6.58865 11.2929 6.97917Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ccd5b364fcc77e9949962a290b5fa924.svg";
export { ForwardRef as ReactComponent };